/**
 * Generated by orval 🍺
 * Do not edit manually.
 * lcm-microservice
 * OpenAPI spec version: 1.0.0
 */
export const FileTypeEnum = {
    'image/jpeg': 'image/jpeg',
    'image/jpg': 'image/jpg',
    'image/png': 'image/png',
    'video/mp4': 'video/mp4',
    'image/gif': 'image/gif',
    'application/zip': 'application/zip',
    'application/x-zip-compressed': 'application/x-zip-compressed',
    'audio/mpeg': 'audio/mpeg',
    'audio/ogg': 'audio/ogg',
    'dco/video': 'dco/video',
    'dco/static': 'dco/static',
    'youtube/video': 'youtube/video',
};
